import { Component, OnInit, Input, ViewChild, EventEmitter, Output, TemplateRef, HostListener, ElementRef, ChangeDetectorRef, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { download, getPageSize, LeadgetPageSize, ResourceAccess, validateAllFormFields } from 'src/app/shared/utils/calsoft-validators';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { CommonService } from 'src/app/services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { RestrictionComponent } from 'src/app/shared/restriction-pop-up/restriction/restriction.component';
import { ImportExcelComponent } from 'src/app/pages/commonImport/import-excel/import-excel.component';
import { CommonDownloadComponent } from 'src/app/pages/common-download/common-download.component';
import { CurrencyPipe, DatePipe, Location } from '@angular/common';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import * as XLSX from 'xlsx';
import { TransferLeadComponent } from 'src/app/shared/transfer-lead/transfer-lead.component';
import { DealsService } from 'src/app/services/deals.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { AddDealsPaymentComponent } from 'src/app/pages/crm/deals/add-deals-payment/add-deals-payment.component';
import { ViewDealsPaymentComponent } from 'src/app/pages/crm/deals/view-deals-payment/view-deals-payment.component';
import { CrmBusinessEditComponent } from 'src/app/shared/crm-business-edit/crm-business-edit.component';
import { UsersService } from 'src/app/services/users.service';

import { CrmSearchComponent } from 'src/app/shared/crm-search/crm-search.component';
import { CurrencyConvertPipe } from 'src/app/shared/pipes/currency-convert.pipe';

@Component({
  selector: 'calsoft-deal-table',
  templateUrl: './deal-table.component.html',
  styleUrls: ['./deal-table.component.scss'],
  providers: [CurrencyPipe, CurrencyConvertPipe]
})
export class DealTableComponent implements OnInit, OnDestroy, OnChanges {

  url = '';
  sanitizedUrl = '';


  @Input() type: any = 1;
  @Input() isCompany: boolean = false;

  @Input() data: any;
  // @Input() leadId: any = 0;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  productList: any;
  private dateFormat = Constant.dateFormat;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  secondFormGroup: any;
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  filterActive: boolean = false;
  sortParam: any = 'updatedDate' + "," + Constant.Dsc;
  pageIndex: any;
  pageSize: number;
  pageList: any;
  spinner: boolean;
  search: any;
  id: any;
  pageSizeValue: any;
  resourcePrivilege: any;
  elements: any
  setList: any = [];
  read: any = false;
  serverPath: any = environment.ImageAPI;
  downloadDataComplete: string;
  create: any;
  productLimitedRestrictionValue: any;
  productLimitedRestriction: boolean = false;
  configurableProductDropdown: any;
  configattributeType: any;
  productSelected: any;

  @Input() primaryTitle = 'Product';

  @Input() dealsPrimaryType: number = 0;

  @Input() secondaryType = 1;
  @Input() DealType = 1;
  urlPage: any;
  urlSize: any;
  urlSort: string;
  redirected: boolean = false;
  crmType: any;
  initCrmType: boolean = false;
  useDefaultHeading: any = false;
  selectUpload: boolean = false;
  isMobile: boolean = window.innerWidth <= 768;
  totaldealsCount: any;
  totalElements: number = 0;
  columnsProperties: string[] = [];
  @Input() leadId: any;
  @Input() defaultSetType: any;
  @Input() defaultSet: any;
  openDealsAmount: any;
  openDealsCount: any;
  wonDealAmount: any;
  wonDealAmountCount: any;

  @HostListener('window:resize', [])
  onResize() {
    this.isMobile = window.innerWidth <= 768;
  }

  currentRouterPath: any;
  @Input() dealsTableView: number = 0;

  constructor(
    private dealsService: DealsService,
    private ecryptService: EcryptServiceService,
    private router: Router,
    private commonService: CommonService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _formBuilder: FormBuilder,
    private location: Location,
    private route: ActivatedRoute,
    private dataPipe: DatePipe,
    private crmsettingsService: CrmsettingsService,
    private cdr: ChangeDetectorRef,
    private usersService: UsersService,
    private currencyPipe: CurrencyPipe,
    public currencyConvertPipe: CurrencyConvertPipe
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.currentRouterPath = this.router.url;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }

  isLeadViewSelected: boolean = false;

  viewType: string = 'leadview';

  selectView(view: string) {
    this.isLeadViewSelected = view === 'leadView';
    this.viewType = view; // Update viewType so that the display changes accordingly
  }


  switchView(type: string) {
    this.viewType = type;
    if (this.viewType === 'kanban') {

    }
  }

  get isCompanyContext(): boolean {
    return this.isCompany || (this.router.url ? this.router.url.toLowerCase().includes('compan') : false);
  }

  getDealAmount(obj: any): number {
    if (!obj) return 0;
    const candidates = [
      obj.openDealAmount,
      obj.open_deal_amount,
      obj.openDealsAmount,
      obj.open_deals_amount,
      obj.amount,
      obj.dealAmount,
      obj.deal_amount,
      obj.dealamount,
      obj['openDealAmount$n'],
      obj['open_deal_amount$n'],
      obj['deal_amount$n'],
      obj['dealamount$n'],
      obj['amount$n'],
      obj['openDealsAmount$n'],
      obj['open_deals_amount$n'],
      obj.dealValue,
      obj.budget,
      obj.value,
      obj.revenue,
      obj.isCustomizedValue?.Open_Deals_Amount,
      obj.isCustomizedValue?.['Open Deals Amount'],
      obj.isCustomizedValue?.['Open deal amount'],
      obj.isCustomizedValue?.['open_deal_amount'],
      obj.isCustomizedValue?.openDealAmount,
      obj.isCustomizedValue?.['Deal Amount'],
      obj.isCustomizedValue?.['deal_amount'],
      obj.isCustomizedValue?.deal_amount,
      obj.isCustomizedValue?.dealAmount,
      obj.isCustomizedValue?.amount,
      obj.downloadList?.['Open Deals Amount'],
      obj.downloadList?.['Deal Amount'],
      obj.values?.open_deal_amount,
      obj.values?.openDealAmount,
      obj.values?.amount,
      obj.values?.deal_amount,
      obj.values?.dealamount,
    ];

    for (const val of candidates) {
      if (val != null && val !== '') {
        const num = typeof val === 'number' ? val : parseFloat(String(val).replace(/[^0-9.]/g, ''));
        if (!isNaN(num) && num > 0) {
          return num;
        }
      }
    }
    return 0;
  }

  getWonDealAmount(obj: any): number {
    if (!obj) return 0;
    const candidates = [
      obj.wonDealAmount,
      obj.won_deal_amount,
      obj.wonDealsAmount,
      obj.won_deals_amount,
      obj['wonDealAmount$n'],
      obj['won_deal_amount$n'],
      obj.isCustomizedValue?.Won_Deals_Amount,
      obj.isCustomizedValue?.['Won Deals Amount'],
      obj.isCustomizedValue?.['Won deal amount'],
      obj.values?.won_deal_amount,
      obj.values?.wonDealAmount,
    ];

    for (const val of candidates) {
      if (val != null && val !== '') {
        const num = typeof val === 'number' ? val : parseFloat(String(val).replace(/[^0-9.]/g, ''));
        if (!isNaN(num) && num > 0) {
          return num;
        }
      }
    }
    return 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      const companyDealAmount = this.getDealAmount(this.data);
      const companyWonAmount = this.getWonDealAmount(this.data);
      if (companyDealAmount > 0 || companyWonAmount > 0) {
        if (!this.productList || (this.productList.data && this.productList.data.length === 0)) {
          this.getAllDeals();
        }
      }
    }
  }

  mapperMap = new Map<string, string>();
  ngOnInit() {

    // Show initial values from cached Solr/company data immediately
    const initialOpen = this.getDealAmount(this.data);
    const initialWon = this.getWonDealAmount(this.data);
    const rawOpen = (this.data && this.data.openDealAmount != null) ? this.data.openDealAmount : initialOpen;
    this.openDealsAmount = parseFloat(rawOpen) || 0;
    this.openDealsCount = (this.data && this.data.openDealAmountCount != null) ? this.data.openDealAmountCount : (this.openDealsAmount > 0 ? 1 : 0);
    const rawWon = (this.data && this.data.wonDealAmount != null) ? this.data.wonDealAmount : initialWon;
    this.wonDealAmount = parseFloat(rawWon) || 0;
    this.wonDealAmountCount = (this.data && this.data.wonDealAmountCount != null) ? this.data.wonDealAmountCount : (this.wonDealAmount > 0 ? 1 : 0);
    this.wonDealAmount = this.currencyConvertPipe.transform(this.wonDealAmount as any);
    this.openDealsAmount = this.currencyConvertPipe.transform(this.openDealsAmount as any);

    this.textAccount = 'OK';
    this.textAccountHousing = 'OK';
    this.downloadDataComplete = 'OK';
    this.urlPage = this.route.snapshot.queryParamMap.get("page")
    this.urlSize = this.route.snapshot.queryParamMap.get("size")
    this.urlSort = this.route.snapshot.queryParamMap.get("sort")

    if (this.urlPage != null) {

      this.page = this.urlPage
    }

    if (this.urlSize != null) {

      this.size = this.urlSize
    }

    if (this.urlSort != null) {

      this.sortParam = this.urlSort
    }
    this.getResource();
    if (this.urlPage != null) {
      this.redirected = true;
    }
    if (this.dealsTableView == 1) {
      this.tableViewMode = 'tableView';
    }

    this.getAllDeals();

  }

  refreshDealAmounts(): void {
    const serviceMethod = this.isCompanyContext ? 'getAllDealssByCompany' : 'getAllDealssByEntityId';

    // Fetch up to 500 deals so we compute the true total without pagination gaps
    this.dealsService[serviceMethod](0, 500, this.sortParamInit, this.leadId).subscribe(
      (res: any) => {
        const allDeals: any[] = (res && res['content']) ? res['content'] : (Array.isArray(res) ? res : []);

        if (allDeals.length > 0) {
          let openAmount = 0;
          let openCount = 0;
          let wonAmount = 0;
          let wonCount = 0;

          allDeals.forEach((deal: any) => {
            const amount = parseFloat(deal.amount) || 0;
            const stage = (deal.stage || '').toLowerCase();

            if (stage === 'won' || stage.includes('won')) {
              wonAmount += amount;
              wonCount++;
            } else {
              openAmount += amount;
              openCount++;
            }
          });

          this.openDealsAmount = this.currencyConvertPipe.transform(openAmount as any);
          this.openDealsCount = openCount;
          this.wonDealAmount = this.currencyConvertPipe.transform(wonAmount as any);
          this.wonDealAmountCount = wonCount;
        } else if (this.isCompanyContext) {
          const companyDealAmount = this.getDealAmount(this.data);
          const companyWonAmount = this.getWonDealAmount(this.data);
          if (companyDealAmount > 0 || companyWonAmount > 0) {
            const isWon = companyWonAmount > 0 && companyDealAmount <= 0;
            if (isWon) {
              this.wonDealAmount = this.currencyConvertPipe.transform((companyWonAmount || companyDealAmount) as any);
              this.wonDealAmountCount = 1;
              this.openDealsAmount = this.currencyConvertPipe.transform(0 as any);
              this.openDealsCount = 0;
            } else {
              this.openDealsAmount = this.currencyConvertPipe.transform(companyDealAmount as any);
              this.openDealsCount = 1;
              this.wonDealAmount = this.currencyConvertPipe.transform((companyWonAmount || 0) as any);
              this.wonDealAmountCount = companyWonAmount > 0 ? 1 : 0;
            }
          }
        }
        this.cdr.detectChanges();
      },
      () => {
        if (this.isCompanyContext) {
          const companyDealAmount = this.getDealAmount(this.data);
          const companyWonAmount = this.getWonDealAmount(this.data);
          if (companyDealAmount > 0 || companyWonAmount > 0) {
            const isWon = companyWonAmount > 0 && companyDealAmount <= 0;
            if (isWon) {
              this.wonDealAmount = this.currencyConvertPipe.transform((companyWonAmount || companyDealAmount) as any);
              this.wonDealAmountCount = 1;
              this.openDealsAmount = this.currencyConvertPipe.transform(0 as any);
              this.openDealsCount = 0;
            } else {
              this.openDealsAmount = this.currencyConvertPipe.transform(companyDealAmount as any);
              this.openDealsCount = 1;
              this.wonDealAmount = this.currencyConvertPipe.transform((companyWonAmount || 0) as any);
              this.wonDealAmountCount = companyWonAmount > 0 ? 1 : 0;
            }
            this.cdr.detectChanges();
          }
        }
      }
    );
  }
  bulkUpload: boolean = false;
  _form: UntypedFormGroup;


  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.DEALS)
      .subscribe((data: any) => {

        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {
          this.read = data.read;
          this.resourcePrivilege = data;
          this.getProduct();

        }
      });
  }

  goToPopUp() {
    const dialogRef = this.dialog.open(CrmSearchComponent, {
      width: '80%',
      maxWidth: '1200px',
      height: '100%',
      data: {

      },
      position: { right: '0' },
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: false
    });
  }




  // filterSelectObj = [
  //   //     {
  //   //   name: 'Select',
  //   //   property: 'disable',
  //   //   type: 'disable',
  //   //   position: 'firstValue',
  //   //   options: [],

  //   // },
  //   {
  //     name: 'Deals Name',
  //     property: 'dealsName',
  //     type: 'text',
  //     position: 'firstValue',
  //     options: []
  //   },
  //   {
  //     name: 'Lead Name',
  //     property: 'leadName',
  //     type: 'text',
  //     position: 'secondValue',
  //     options: []
  //   },
  //   {
  //     name: 'Amount',
  //     property: 'amount',
  //     type: 'text',
  //     position: 'thirdValue',
  //     options: []
  //   },
  //   {
  //     name: 'Probability',
  //     property: 'probability',
  //     type: 'text',
  //     position: 'fourthValue',
  //     options: []
  //   },
  //   {
  //     name: 'Stage',
  //     property: 'stage',
  //     type: 'multiSelect',
  //     position: 'fifthValue',
  //     options: []
  //   },
  //   {
  //     name: 'Closing Date',
  //     property: 'createdDate',
  //     type: 'date',
  //     position: 'sixthValue',
  //     options: []
  //   },
  //   {
  //     name: 'ContactName',
  //     property: 'contactName',
  //     type: 'text',
  //     position: 'seventhValue',
  //     options: []
  //   },

  //    {
  //     name: 'Paid',
  //     property: 'paid',
  //     type: 'text',
  //     position: 'eighthValue',
  //     options: []
  //   },

  //    {
  //     name: 'Balance',
  //     property: 'balance',
  //     type: 'text',
  //     position: 'ninthValue',
  //     options: []
  //   },

  //   {
  //     name: 'Payment Status',
  //     property: 'paymentStatus',
  //     type: 'text',
  //     position: 'tenthValue',
  //     options: []
  //   },
  // ]

  // @Input()
  columns: ListColumn[] = [
    // { name: 'select', property: 'select', visible: true, isModelProperty: false },
    { name: 'Deals Name', property: 'dealsName', visible: true, isModelProperty: true },
    { name: 'Amount', property: 'amount', visible: true, isModelProperty: true },
    { name: 'Paid', property: 'paid', visible: true, isModelProperty: true },
    { name: 'Balance', property: 'balance', visible: true, isModelProperty: true },
    { name: 'Stage', property: 'stage', visible: true, isModelProperty: true },
    { name: 'Closing Date', property: 'closingDate', visible: true, isModelProperty: false },
    // { name: 'Contact Name', property: 'leadName', visible: true, isModelProperty: true },
    // { name: 'Payment Status', property: 'paymentStatus', visible: true, isModelProperty: false },
    { name: 'Action', property: 'actions', visible: true, disabled: true },
  ] as ListColumn[];


  filterSelectObj = [
    {
      name: 'Name',
      property: 'name',
      type: 'text',
      position: 'firstValue',
      options: []
    },
    {
      name: 'Webiste',
      property: 'website',
      type: 'text',
      position: 'secondValue',
      options: []
    },
    {
      name: 'Phone No',
      property: 'phoneNumber',
      type: 'text',
      position: 'thirdValue',
      options: []
    },
    {
      name: 'No of employees',
      property: 'noOfemployees',
      type: 'text',
      position: 'fourthValue',
      options: []
    },
    {
      name: 'Open deal amount',
      property: 'dealamount',
      type: 'text',
      position: 'fifthValue',
      options: []
    },
    {
      name: 'Tags',
      property: 'tagName',
      type: 'select',
      position: 'sixthValue',
      options: [],
      display: true
    },
    {
      name: 'Industry Type',
      property: 'industryType',
      type: 'select',
      position: 'seventhValue',
      options: []
    },
    {
      name: 'Sales Owner',
      property: 'dealsOwner',
      type: 'multiSelect',
      position: 'eighthValue',
      options: [],
      display: true
    },

    {
      name: 'Busniess Type',
      property: 'businessType',
      type: 'select',
      position: 'ninthValue',
      options: [],
      display: true
    },
  ]

  companyList: any;
  totalLeadCount: any;
  sortParamInit: any = 'updatedDate' + "," + Constant.Dsc;

  getAllDeals() {
    this.spinner = true;
    const sort = this.sortParam != undefined ? this.sortParam : this.sortParamInit;

    if (this.isCompanyContext) {
      this.dealsService.getAllDealssByCompany(this.page, this.size, sort, this.leadId).subscribe(
        (res: any) => {
          this.spinner = false;
          let items: any[] = (res && res['content']) ? res['content'] : (Array.isArray(res) ? res : []);

          if (items.length > 0) {
            this.productList = new MatTableDataSource(items);
            this.elements = res['numberOfElements'] || items.length;
            this.pageList = res['totalElements'] || items.length;
            this.pageSizeValue = getPageSize(this.pageList);
            this.refreshDealAmounts();
          } else {
            this.fetchCompanyDealsFallback();
          }
        },
        error => {
          this.fetchCompanyDealsFallback();
        }
      );
    } else {
      this.dealsService.getAllDealssByEntityId(this.page, this.size, sort, this.leadId).subscribe(
        (res: any) => {
          this.spinner = false;
          const items: any[] = (res && res['content']) ? res['content'] : (Array.isArray(res) ? res : []);
          this.productList = new MatTableDataSource(items);
          this.elements = res['numberOfElements'] || items.length;
          this.pageList = res['totalElements'] || items.length;
          this.pageSizeValue = getPageSize(this.pageList);
          this.refreshDealAmounts();
        },
        error => {
          this.spinner = false;
        }
      );
    }
  }

  fetchCompanyDealsFallback() {
    const sort = this.sortParam != undefined ? this.sortParam : this.sortParamInit;
    this.dealsService.getAllDealssByEntityId(this.page, this.size, sort, this.leadId).subscribe(
      (res: any) => {
        this.spinner = false;
        let items: any[] = (res && res['content']) ? res['content'] : (Array.isArray(res) ? res : []);
        if (items.length > 0) {
          this.productList = new MatTableDataSource(items);
          this.elements = res['numberOfElements'] || items.length;
          this.pageList = res['totalElements'] || items.length;
          this.pageSizeValue = getPageSize(this.pageList);
          this.refreshDealAmounts();
        } else {
          this.handleSyntheticCompanyDeal();
        }
      },
      error => {
        this.spinner = false;
        this.handleSyntheticCompanyDeal();
      }
    );
  }

  handleSyntheticCompanyDeal() {
    this.spinner = false;
    const companyDealAmount = this.getDealAmount(this.data);
    const companyWonAmount = this.getWonDealAmount(this.data);

    if (companyDealAmount > 0 || companyWonAmount > 0) {
      const effectiveAmount = companyDealAmount > 0 ? companyDealAmount : companyWonAmount;
      const isWon = companyWonAmount > 0 && companyDealAmount <= 0;
      const dealTitle = this.data?.dealName ||
                        this.data?.dealsName ||
                        this.data?.deal_name ||
                        (this.data?.name ? `${this.data.name} - Deal` : 'Company Deal');
      const dealStage = this.data?.dealStage ||
                        this.data?.stage ||
                        this.data?.tagName ||
                        this.data?.statusName ||
                        (isWon ? 'Closed Won' : 'Active');

      const rawDate = this.data?.expectedClosingDate ||
                      this.data?.closingDate ||
                      this.data?.closingDates ||
                      this.data?.updatedDate;

      const syntheticRow: any = {
        entityId: this.data?.dealId || this.data?.entityId || this.leadId,
        attributeSetId: this.defaultSet || this.data?.attributeSetId || 0,
        dealsName: dealTitle,
        amount: effectiveAmount,
        paid: this.data?.paid != null ? this.data.paid : 0,
        balance: this.data?.balance != null ? this.data.balance : (effectiveAmount - (this.data?.paid || 0)),
        stage: dealStage,
        closingDate: rawDate,
        isCompanyDeal: true
      };

      this.productList = new MatTableDataSource([syntheticRow]);
      this.elements = 1;
      this.pageList = 1;
      this.pageSizeValue = getPageSize(1);

      if (isWon) {
        this.wonDealAmount = this.currencyConvertPipe.transform(effectiveAmount as any);
        this.wonDealAmountCount = 1;
        this.openDealsAmount = this.currencyConvertPipe.transform(0 as any);
        this.openDealsCount = 0;
      } else {
        this.openDealsAmount = this.currencyConvertPipe.transform(effectiveAmount as any);
        this.openDealsCount = 1;
        this.wonDealAmount = this.currencyConvertPipe.transform((companyWonAmount || 0) as any);
        this.wonDealAmountCount = companyWonAmount > 0 ? 1 : 0;
      }
    } else {
      this.productList = new MatTableDataSource([]);
      this.elements = 0;
      this.pageList = 0;
      this.openDealsAmount = this.currencyConvertPipe.transform(0 as any);
      this.openDealsCount = 0;
      this.wonDealAmount = this.currencyConvertPipe.transform(0 as any);
      this.wonDealAmountCount = 0;
    }
    this.cdr.detectChanges();
  }

  getProduct() {
    this.firstFormGroup.value.sortBy = this.sortParam.split(",")[1]
    this.firstFormGroup.patchValue(this.firstFormGroup.value)
    this.filterActive = false;
    this.spinner = true;
    if (this.isCompanyContext) {
      this.getAllDeals();
      return;
    }
    if (this.DealType == 2) {
      this.dealsService.getAllDealssByEntityId(this.page, this.size, this.sortParam, this.leadId).subscribe(
        res => {
          this.spinner = false;
          this.dataSource.data = res['content'].map((element: any) => {
            return {
              ...element,
              darkTextColor: this.getAdjustedColor(element.leadStatusColour, 50)// adjust darkness here
            };
          });
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          console.log(this.productList);

          this.productList.sort = this.sort;
          this.pageList = res['totalElements'];
          this.productList.paginator = this.paginator;
          this.pageSizeValue = LeadgetPageSize(this.pageList);


          this.cdr.detectChanges();
          this.totalElements = res['totalElements'];
          this.totaldealsCount = res['totalElements'];


        },
        error => {
          this.spinner = false;
        }
      )
    }
    else {
      this.dealsService.getDeals(this.page, this.size, this.sortParam, this.type, this.leadId).subscribe(
        res => {
          this.spinner = false;
          this.dataSource.data = res['content'].map((element: any) => {
            return {
              ...element,
              darkTextColor: this.getAdjustedColor(element.leadStatusColour, 50)// adjust darkness here
            };
          });
          this.productList = new MatTableDataSource();
          this.elements = res['numberOfElements'];
          this.productList = res['content'];
          console.log(this.productList);

          this.productList.sort = this.sort;
          this.pageList = res['totalElements'];
          this.productList.paginator = this.paginator;
          this.pageSizeValue = LeadgetPageSize(this.pageList);


          this.cdr.detectChanges();
          this.totalElements = res['totalElements'];
          this.totaldealsCount = res['totalElements'];


        },
        error => {
          this.spinner = false;
        }
      )
    }

  }

  getUpdate(event) {
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;
    let localtion = this.router.url;
    const questionMarkIndex = localtion.indexOf('?');

    if (questionMarkIndex !== -1) {
      // Extract the substring before the ?
      const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

      // Replace the original string with the substring before the ?
      localtion = beforeQuestionMark;
    }

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];

    localtion = localtion.split('&page')[0]

    //  this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

    this.redirected = false;

    this.DetectingRequestType();
  }

  sortData(event) {
    if (event.active != 'categoryNames' && event.active != 'icons' && event.active != 'select' && event.active != 'actions') {

      if (this.size != Constant.SIZE) {

        this.size = this.size;

      } else {
        this.size = Constant.SIZE;
      }
      this.page = Constant.PAGE;

      this.sortParam = event.active;

      if (event.direction.length > 0) {

        if (this.mapperMap.get(event.active) != null) {
          if (event.direction == 'asc') {
            this.sortParam = this.mapperMap.get(event.active);
            this.sortParam = this.sortParam + "," + Constant.Asc;
          } else if (event.direction == 'desc') {
            this.sortParam = this.mapperMap.get(event.active);
            this.sortParam = this.sortParam + "," + Constant.Dsc;
          }
        }
        else {
          if (event.direction == 'asc') {
            this.sortParam = this.sortParam + "," + Constant.Asc;
          } else if (event.direction == 'desc') {
            this.sortParam = this.sortParam + "," + Constant.Dsc;
          }
        }
        let localtion = this.router.url;
        const questionMarkIndex = localtion.indexOf('?');

        if (questionMarkIndex !== -1) {
          // Extract the substring before the ?
          const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

          // Replace the original string with the substring before the ?
          localtion = beforeQuestionMark;
        }

        let url = this.router.url;
        let cleanUrl = url.split('?')[0];

        localtion = localtion.split('&page')[0]
        //  this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

        this.redirected = false;
        this.DetectingRequestType();
      }


    }

  }

  DetectingRequestType() {
    if (!this.filterActive) {

      this.getAllDeals();
    }
    else {
      this.filterOption(this.search);
    }
  }

  filterOption(event) {
    if (this.redirected == true) {
      this.urlPage = this.route.snapshot.queryParamMap.get("page")
      this.urlSize = this.route.snapshot.queryParamMap.get("size")
      this.urlSort = this.route.snapshot.queryParamMap.get("sort")
      if (this.urlPage != null) {
        this.redirected = true;

        this.page = this.urlPage;
        this.size = this.urlSize;
        if (this.urlSort != null) {
          this.sortParam = this.sort;
        } else {
          this.sortParam = 'updatedDate' + "," + Constant.Dsc;
        }

      }
      this.firstFormGroup.value.page = this.page;
      this.firstFormGroup.value.size = this.size;
    }
    this.filterActive = true;
    this.search = event;

    if (this.type == 2) {

      this.search = `${this.search}`
    }

    this.spinner = true;
    this.dealsService.getDealsBySearchMain(this.search, this.page, this.size, this.sortParam, this.leadId).subscribe(
      res => {
        this.spinner = false;


        if (!this.selectUpload) {
          this.productList = res['content'];
          this.elements = res['numberOfElements'];
          this.pageList = res['totalElements'];
          this.pageSizeValue = LeadgetPageSize(this.pageList);
        } else {
          this.downloadDataFinal(res['content'])
        }

      },
      error => {
        this.spinner = false;
      })

  }
  applyFilter(filterValue: string) {
    this.productList.filter = filterValue.trim().toLowerCase();
  }

  addproduct() {
    let dealId = 0;

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        let setId = data['defaultDealsSet'];

        if (this.type == 1) {
          this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}`])
        } else {
          this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}/${this.leadId}`])
        }
      } catch (error) {
        console.error('Error decrypting or parsing userSettingsData:', error);
      }

    }
  }


  onFilterChange(value, index) {
    if (value == '') {
      this.leadIdList = [];
      this.selectionLead = [];
      let localtion = this.router.url;
      this.getProduct();
      this.search = '';
    }
    else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;

      if (index == 1) {
        this.redirected = false;
        let localtion = this.router.url;
        const questionMarkIndex = localtion.indexOf('?');



        if (questionMarkIndex !== -1) {
          // Extract the substring before the ?
          const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

          // Replace the original string with the substring before the ?
          localtion = beforeQuestionMark;
        }

        let url = this.router.url;
        let cleanUrl = url.split('?')[0];

        localtion = localtion.split('&page')[0]


        if (this.sortParam == undefined) {
          this.sortParam = 'updatedDate' + "," + Constant.Dsc;
        }

        //  this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

        this.redirected = false;
      }

      let val = parseInt(localStorage.getItem(Constant.SU))
      if (val > 0) {
        let searchTerm = "dealsName:" + '*' + value.trim() + '*'
          + "' AND amount:" + '*' + val + '*'
          + "' OR stage:" + '*' + value.trim() + '*' + "' "
        this.filterOption(searchTerm)
      } else {
        let searchTerm = "dealsName:" + '*' + value.trim() + '*'
          + "' OR accountName:" + '*' + value.trim() + '*' + "' "
        this.filterOption(searchTerm)
      }

    }
  }

  onFilterChangeColumn(i, index) {
    if (i == undefined) {
      this.leadIdList = [];
      this.selectionLead = [];
      this.filterActive = false
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;

      let location = this.router.url;
      const questionMarkIndex = location.indexOf('?');



      if (questionMarkIndex !== -1) {
        // Extract the substring before the ?
        const beforeQuestionMark = location.substring(0, questionMarkIndex);

        // Replace the original string with the substring before the ?
        location = beforeQuestionMark;
      }

      let url = this.router.url;
      let cleanUrl = url.split('?')[0];

      this.sortParam = 'updatedDate' + "," + Constant.Dsc;

      //this.location.go(`${cleanUrl}`)

      this.getProduct();

    } else {
      i = i.replace(/'/g, '');
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      let val: any | null = null;

      const encryptedUserSettings = localStorage.getItem('userSettingsData');

      if (encryptedUserSettings) {
        try {
          const decrypted = this.ecryptService.decryptionAES(encryptedUserSettings);
          const userSettings = JSON.parse(decrypted);
          val = userSettings.userType;
        } catch (error) {
          console.error('Error decrypting or parsing userSettingsData:', error);
        }
      }

      if (!val) {
        const encryptedSigninDetails = localStorage.getItem('signinDetails');
        if (encryptedSigninDetails) {
          try {
            const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
            const signinDetails = JSON.parse(decrypted);
            val = signinDetails.userType;
          } catch (error) {
            console.error('Error decrypting or parsing signinDetails:', error);
          }
        }
      }

      if (val > 0) {
        i = i + " AND supplierId_cust:" + '*' + val + '*' + "'"

        if (index == 1) {
          this.redirected = false;
          let localtion = this.router.url;
          const questionMarkIndex = localtion.indexOf('?');



          if (questionMarkIndex !== -1) {
            // Extract the substring before the ?
            const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

            // Replace the original string with the substring before the ?
            localtion = beforeQuestionMark;
          }

          let url = this.router.url;
          let cleanUrl = url.split('?')[0];

          localtion = localtion.split('&page')[0]


          if (this.sortParam == undefined) {
            this.sortParam = 'updatedDate' + "," + Constant.Dsc;
          }

          //     this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

          this.redirected = false;
        }

        this.filterOption(i)
      } else {

        if (index == 1) {
          this.redirected = false;
          let localtion = this.router.url;
          const questionMarkIndex = localtion.indexOf('?');



          if (questionMarkIndex !== -1) {
            // Extract the substring before the ?
            const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

            // Replace the original string with the substring before the ?
            localtion = beforeQuestionMark;
          }

          let url = this.router.url;
          let cleanUrl = url.split('?')[0];

          localtion = localtion.split('&page')[0]


          if (this.sortParam == undefined) {
            this.sortParam = 'updatedDate' + "," + Constant.Dsc;
          }

          // this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

          this.redirected = false;
        }

        this.filterOption(i);
      }

    }
  }

  exportExcel() {
    this.router.navigate([`/deals/export-deals`])
  }

  importExcel() {
    this.router.navigate([`/deals/import-deals`])
  }

  downloadReportTemplate() {
    this.dealsService.downloadProductTemplate().subscribe(
      data => {
        download(data);
      },
    )
  }

  downloadTemplate1() {
    this.dealsService.downloadProductNameTemplate().subscribe(
      data => {
        download(data);
      },
    )
  }

  exportGmc() {
    this.dealsService.downloadGmc().subscribe(
      data => {
        download(data);
      },
    )
  }

  sitedata() {
    this.dealsService.downloadshopdata().subscribe(
      data => {
        download(data);
      }
    )
  }

  openImportDataPopup() {
    let dialogRef = this.dialog.open(ImportExcelComponent, {
      disableClose: true,
      width: '900px',
      data: { url: 'excelImportProductQtyAndPrice' }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      if (result['event'] != 'close') {
        this.getProduct();
      }
    });
  }


  openImportDataPopup1() {
    let dialogRef = this.dialog.open(ImportExcelComponent, {
      disableClose: true,
      width: '900px',
      data: { url: 'excelImportProductNameAndDescription' }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      if (result['event'] != 'close') {
        this.getProduct();
      }
    });
  }

  @ViewChild('delete') delete: TemplateRef<any>;

  deleteAllProductDialog() {
    let dialogRef = this.dialog.open(this.delete, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  deleteAllProduct() {

    if (this.resourcePrivilege?.delete) {


      this.spinner = true;
      this.dealsService.deleteAllLead().subscribe(
        response => {
          this.spinner = false;
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.getProduct();
            this.getAllDeals();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        error => {
          this.spinner = false;
        })

    }

  }
  dateRangeValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const start = group.get('start')?.value;
    const end = group.get('end')?.value;
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffInDays = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
      if (diffInDays > 7) {
        return { 'exceedsMaxRange': true };
      }
    }
    return null;
  }

  @ViewChild('delete1') delete1: TemplateRef<any>;

  deleteIndividualDialog() {
    let dialogRef = this.dialog.open(this.delete1, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  deleteAllProductId(rowOrId: any) {
    const id = (rowOrId && typeof rowOrId === 'object') ? rowOrId.entityId : rowOrId;
    const isSynthetic = (rowOrId && typeof rowOrId === 'object') ? rowOrId.isCompanyDeal : false;
    if (isSynthetic) {
      this.snackBar.open('Cannot delete company default deal from here', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 2000 });
      return;
    }
    this.spinner = true;
    this.textAccount = "Processing";
    this.dealsService.deleteByDealsId(id).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getProduct()
          this.getAllDeals();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })

  }

  editProduct(dealId, setId) {
    if (this.type == 1) {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}`]);
    }
    else if (this.isCompanyContext) {
      if (dealId && dealId !== this.leadId) {
        this.router.navigate([`deals/add-edit-deals-company/${dealId}/${setId}/${this.leadId}`]);
      } else {
        this.router.navigate([`deals/add-edit-deals-company/0/${setId || this.defaultSet || 0}/${this.leadId}`]);
      }
    }
    else {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}/${this.leadId}`]);
    }

    if (this.type == 2) {
      this.dialog.closeAll();
    }
  }

  public serverPath4 = environment.commonImageApiNew
  public serverPath7 = environment.commonImageApi + "catalog/product";
  public serverPath8 = environment.commonImageApi;

  getImage(value, images, row) {

    if (row.maintainImageIndConfProduct == 1 && row.type == 'Variants') {



      let i = 0
      let key = '';

      this.configurableProductDropdown = row['configProduct'];

      if (this.configurableProductDropdown != null) {
        for (let key of Object.keys(this.configurableProductDropdown)) {
          if (i == 0) {
            key = key;
            this.productSelected = JSON.parse(this.configurableProductDropdown[key]);

            break;
          }

        }


        // let productSelected = JSON.parse(this.configurableProductDropdown[key]);



        value = this.productSelected['productImageUrl']
        images = this.productSelected['images']
      }
      if (value == '') {
        if (images != null) {

          if (images.length > 0) {
            value = images[0]
          }



        }
      }


    }

    if (value != null) {

      if (value.includes('external')) {
        return this.serverPath8 + value;
      }
      if (value.includes('commonimages')) {
        return this.serverPath7 + value;
      }
      else if (value.includes('http')) {
        return value;
      } else if (!value.includes('medicineimages')
        && !value.includes('http')) {

        return this.serverPath + '/' + value;
      } else if (!value.includes('medicineimages')) {
        return this.serverPath4 + value;
      } else {
        return "assets/images/logo/no-image.png";
      }

    }
  }





  //seleted data

  selectionLead: any = [];
  public attributeIdList: any = [];
  public attributeListForProduct: any = [];
  @Output() onConfirAttribute: EventEmitter<any> = new EventEmitter<any>();

  checkBoxControl: UntypedFormControl = new UntypedFormControl();
  changeValue(isChecked: boolean, row) {


    if (isChecked) {

      let indexForSelection = this.leadIdList.findIndex(
        x => x.dealsOwner == row.dealsOwner && x.leadId == row.entityId
      );

      if (indexForSelection < 0) {
        this.selectionLead.push(row.entityId);
        let object = {
          'dealsOwner': row.dealsOwner,
          'leadId': row.entityId
        }
        this.leadIdList.push(object);
        this.checkBoxControl.patchValue(row.entityId)
      }

    } else {
      let indexForSelectedIncrementId = this.selectionLead.findIndex(x => x == row.entityId)

      this.selectionLead.splice(indexForSelectedIncrementId, 1);

      let indexForSelected = this.selectionLead.findIndex(x => x.leadId == row.entityId)

      this.leadIdList.splice(indexForSelected, 1);


    }

    console.log(this.leadIdList);

    this.onConfirAttribute.emit(this.attributeListForProduct);
  }

  selection = new SelectionModel<any>(true, []);
  attributeList: any = [];
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.attributeList.length;
    return numSelected === numRows;

  }

  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }


    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  textAccount: string;
  textAccountHousing: string;

  submit() {
    this.deleteAllProduct();
    this.dialog.closeAll();
  }



  submit1() {
    this.dialog.closeAll();
  }

  downloadReport(value) {

    if (value == 'full') {
      this.selectionLead = [];
    }

    this.downloadDataComplete = "Processing";
    this.dealsService.downloadProductReportPrimary(this.page, this.size, this.sortParam, this.selectionLead).subscribe(
      data => {
        this.downloadDataComplete = "OK";
        this.dialog.closeAll();
        download(data);
        this.selectionLead = [];
      },
    )
  }

  @ViewChild('download') download: TemplateRef<any>;

  openDialog() {
    let dialogRef = this.dialog.open(this.download, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  firstFormGroup = this._formBuilder.group({
    page: ['', Validators.required],
    size: ['', Validators.required],
    sort: ['', Validators.required],
    sortBy: ['0']

  });

  booleanField: any = [
    { "value": "asc", "viewValue": "ASC" },
    { "value": "desc", "viewValue": "DESC" },
  ]

  downloadData() {

    if (this.firstFormGroup.valid) {
      console.log(this.firstFormGroup);
      this.page = this.firstFormGroup.value.page;
      this.sortParam = this.firstFormGroup.value.sort;
      this.size = this.firstFormGroup.value.size;
      if (this.firstFormGroup.value.sortBy == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (this.firstFormGroup.value.sortBy == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.downloadReport('full');

    } else {
      this.firstFormGroup.markAllAsTouched();

    }
  }

  restritionPopup() {

    let dialogRef = this.dialog.open(RestrictionComponent, {
      width: '350px',
    });
  }

  details(leadId, setId) {

    this.router.navigate([`dealsDetail/${leadId}`])
  }

  @Input() removeColummn: any = ['attributeSetId', 'attributeSetName', 'campaignSource', 'closingDate',
    'dateField', 'day', 'dealsOwner', 'description', 'email', 'entityId', 'expectedRevenue', 'isCustomizedValue',
    'isCustomizedValueString', 'jsonRecieved', 'leadSource', 'month', 'phoneNumber', 'probability', 'roleName', 'sku', 'statusId',
    'tenantId', 'type', 'updatedDate', 'ast', 'additionalSpec', 'values', 'valuesString', 'activityCountOnLead',
    'Campaign Source', 'Contact Name', 'Deal Name', 'Description', 'descriptionInformation', 'downloadList', 'Created Date', 'Updated Date', '', 'Expected Revenue', 'Lead Name', 'Lead Source', 'Next Step',
    'Reason For Loss', 'empty', 'facetFields', 'facetPivotFields', 'facetQueryResult', 'numberOfElements', 'year'];

  exportDataFilter() {
    if (window.innerWidth < 768) {
      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        maxWidth: '100vh',
        height: '100vh',
        width: '100%', disableClose: true,
        data: {
          url: 'getDealsBySearch',
          obj: this.filterSelectObj,
          columns: this.columns,
          colummnToBeRemoved: this.removeColummn,
          useDefaultHeading: false,
          url2: 'getDeals',
          header: ['Deals Name'],
          service: 'dealsService',
          headerName: 'Deals Download',
          dowloadFileName: 'Deals'
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {

        }
      });
    }
    else {
      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        height: '400px',
        disableClose: true,
        data: {
          url: 'getDealsBySearch',
          obj: this.filterSelectObj,
          columns: this.columns,
          colummnToBeRemoved: this.removeColummn,
          useDefaultHeading: false,
          url2: 'getDeals',
          header: ['Deals Name'],
          service: 'dealsService',
          headerName: 'Deals Download',
          dowloadFileName: 'Deals'
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {

        }
      });

    }

  }

  exportDataFilterSelected(type) {
    let i = 0;
    let ownerText = "dealsOwner:*"
    let leadText = "entityId:*"
    this.leadIdList.forEach(element => {



      if (i == 0) {
        ownerText = ownerText + element.dealsOwner + ",";;

        leadText = leadText + element.dealId + ",";
      } else {
        ownerText = ownerText + "," + element.dealsOwner;

        leadText = leadText + "," + element.dealId;
      }



      i++;
    });

    let finalText = ownerText + '*' + ' AND ' + leadText;


    console.log(finalText);

    this.selectUpload = true;

    this.filterOption(finalText);
  }

  leadIdList: any = [];

  transferLead() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(TransferLeadComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "dealsOwners": this.leadIdList,
          "leadIds": this.selectionLead,
          "typeData": 2
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.DetectingRequestType();
          this.leadIdList = [];
          this.selectionLead = [];
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(TransferLeadComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "dealsOwners": this.leadIdList,
          "leadIds": this.leadIdList,
          "typeData": 2
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.DetectingRequestType();
          this.leadIdList = [];
          this.selectionLead = [];
        }
      });
    }
  }

  downloadDataFinal(downLoadData) {

    if (this.router.url.includes('/deals')) {
      downLoadData = downLoadData
        .filter(record => record.downloadList != null) // Filter out null or undefined downloadList
        .map(record => record.downloadList);
    }



    if (this.removeColumn.length > 0) {
      downLoadData = this.removeColumn(downLoadData)
    }



    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    // XLSX.utils.sheet_add_aoa(ws, Heading);

    if (this.useDefaultHeading) {
      XLSX.utils.sheet_add_aoa(ws, []);
      XLSX.utils.sheet_add_json(ws, downLoadData, {
        origin: 'A2',
        skipHeader: true
      });

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      let filename = 'Lead' + '.xlsx'
      XLSX.writeFile(wb, filename);
    } else {
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(downLoadData);

      // Create a workbook with a single sheet
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // Save the workbook as an Excel file
      let filename = 'Lead' + '.xlsx'
      XLSX.writeFile(wb, filename);
    }
    this.selectionLead = [];
    this.selectUpload = false;
    this.leadIdList = []


  }


  removeColumn(downloadData) {

    this.downloadData = downloadData.map(obj => {
      for (const column of this.removeColummn) {
        delete obj[column];
      }
      return obj;
    });


    return this.downloadData;

  }

  importExcelAdvance() {
    this.router.navigate([`deals/xlMapper`])
  }

  addPayment(row) {

    this.paymentModel(row);

  }


  paymentModel(row) {
    const balance = (row && row.balance !== undefined && row.balance !== null)
      ? Number(row.balance)
      : (Number(row?.amount || 0) - Number(row?.paid || 0));

    if (balance <= 0 || row?.paymentStatus == 'Paid') {
      this.snackBar.open('Payment status is already paid for the Sales', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
    } else {
      if (window.innerWidth > 768) {

        let dialogRef = this.dialog.open(AddDealsPaymentComponent, {
          width: '790px',
          data: {
            dealId: row.entityId,
            finalData: row,
          }


        });

        dialogRef.disableClose = true;
        dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();


        });

      }
      else {
        let dialogRef = this.dialog.open(AddDealsPaymentComponent, {
          minWidth: '100vw', height: '100vh',
          data: {
            dealId: row.entityId,
            finalData: row,
          }

        });

        dialogRef.disableClose = true;
        dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
        });
      }
    }
  }

  ViewDealsPayment(row) {

    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ViewDealsPaymentComponent, {
        width: '1000px',
        data: {
          finalData: row,
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();
      });

    }
    else {
      let dialogRef = this.dialog.open(ViewDealsPaymentComponent, {
        minWidth: '100vw',
        height: '100vh',
        data: {
          finalData: row,
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();
      });
    }
  }

  // Get a reference to the scrollable container element in the template
  @ViewChild('stepsWrapper') stepsWrapper!: ElementRef<HTMLDivElement>;

  // Flags to disable/enable arrow buttons
  isAtStart = true;
  isAtEnd = false;

  // Sample data for the setup guide steps
  setupSteps: any[] = [
    { id: 1, icon: 'auto_awesome', label: 'Personalize your CRM', status: 'active' },
    { id: 2, icon: 'download', label: 'Import Deals', status: 'pending' },
    // { id: 3, icon: 'language', label: 'Bring in website leads', status: 'completed' },
    // { id: 4, icon: 'person_add', label: 'Invite your team', status: 'pending' },
    // { id: 5, icon: 'alt_route', label: 'Route leads to your team', status: 'pending' },
    // { id: 6, icon: 'track_changes', label: 'Set up goals', status: 'pending' },
    // { id: 7, icon: 'phone_in_talk', label: 'Configure phone', status: 'pending' },
    // { id: 8, icon: 'mail', label: 'Connect your email', status: 'pending' },
  ];

  onStepClick(step: any) {
    if (step.label === 'Personalize your CRM') {
      this.openBusinessEditDialog();
    }
    else if (step.label === 'Import Deals') {
      this.importExcel();
    }

    else {
      //console.log('Clicked step:', step);
    }
  }

  openBusinessEditDialog(): void {
    const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
      width: '800px',
      // height: '600px', 
      panelClass: 'business-edit-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result['event'] == 'add') {
        window.location.reload();
        console.log("here dialog close");

      }
    });
  }

  scroll(direction: 'left' | 'right'): void {
    const element = this.stepsWrapper.nativeElement;
    // Scroll by 80% of the container's width for a smooth page-like scroll
    const scrollAmount = element.clientWidth * 0.8;

    if (direction === 'left') {
      element.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      element.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    // We need to wait for the smooth scroll to finish before checking the position.
    // A timeout is a simple way to approximate this.
    setTimeout(() => this.checkScrollPosition(), 500);
  }
  checkScrollPosition(): void {
    const { scrollLeft, scrollWidth, clientWidth } = this.stepsWrapper.nativeElement;
    this.isAtStart = scrollLeft === 0;
    // Check if we are at the end (with a small tolerance for fractional pixels)
    this.isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
  }

  viewMode: 'compact' | 'comfortable' = 'compact';
  tableViewMode: 'tableView' | 'kanbanView' = "kanbanView"

  setView(mode: 'compact' | 'comfortable') {
    this.viewMode = mode;
  }
  setTableView(mode: 'tableView' | 'kanbanView') {
    this.tableViewMode = mode;
  }

  applyFiltersAndClose(): void {
    this._buildAndFetchFilters();
    this.isFilterPanelOpen = false;
  }


  isFilterPanelOpen = false;
  activeFilters: any[] = [];
  appliedFilterCount = 0;
  private filterQuery: string | null = null;
  isFilterPanelColumnOpen = false;
  toggleFilterPanel(): void {
    this.isFilterPanelOpen = !this.isFilterPanelOpen;
    if (this.isFilterPanelOpen) {
      this.isFilterPanelColumnOpen = false;
    }
  }

  addFilter(): void {
    this.activeFilters.push({ field: '', value: '' });
  }

  removeFilter(index: number): void {
    this.activeFilters.splice(index, 1);
    this._buildAndFetchFilters();
  }
  private _buildAndFetchFilters(): void {
    const queryParts = this.activeFilters
      .filter(f => f.field && f.value)
      .map(f => `${f.field}:*${f.value}*`);
    this.filterQuery = queryParts.length > 0 ? queryParts.join(' AND ') : null;
    this.appliedFilterCount = queryParts.length;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.page = 0;
    if (queryParts.length > 0) {
      this.getLeadsFilter(); // Hypothetical method if filters exist
    } else {
      this.getProduct(); // Called when no filters are present
    }
  }

  getLeadsFilter() {
    // this.productService
    //   .getLeadBySearch(this.filterQuery, this.page, this.size, this.sortParam)
    //   .subscribe(
    //     res => {
    //       this.spinner = false;
    //       this.dataSource.data = res['content'].map((element: any) => {
    //         return {
    //           ...element,
    //           darkTextColor: this.getAdjustedColor(element.leadStatusColour, 60)
    //         };
    //       });
    //       this.newContactCount = res['totalElements'];
    //     },
    //     error => {
    //       this.spinner = false;
    //       console.error("Error fetching leads:", error);
    //     }
    //   );
  }

  activeTab: 'all' | 'new' = 'all'; // default tab


  onTabClick(tab: 'all' | 'new', event: Event): void {
    event.preventDefault(); // prevent default anchor behavior

    this.activeTab = tab;

    if (tab === 'new') {
      this.filterQuery = 'statusName:*Pending*';
      this.page = 0;
      this.getLeadsFilter();
    } else if (tab === 'all') {
      this.page = 0;
      this.getProduct();
    }
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }
  selectAllForBulkAction() {
    this.masterToggle();
  }

  allColumns: { key: string; name: string; }[] = [
    { key: 'name', name: 'Name' },
    { key: 'customValuesIsAccount', name: "Account" },
    { key: 'customValuesIsJob', name: "Job_Title" },
    { key: 'phoneNumber', name: 'Mobile' },
    { key: 'email', name: 'Email' },
    { key: 'statusName', name: 'Status' },
    { key: 'sourceName', name: 'Lead Source' },
    { key: 'ownerIdName', name: 'Sales Owner' },
    { key: 'createdDate', name: 'Created Date' },
    { key: 'updatedDate', name: 'Last Updated' },
    { key: 'lastActivityNotes', name: 'Last Activity' },
    { key: 'Tags', name: 'Tags' },
    { key: 'entityId', name: 'ID' }
  ];
  defaultColumns: string[] = ['select', 'name', 'customValuesIsAccount', 'customValuesIsJob', 'email', 'phoneNumber', 'statusName', 'Tags', 'ownerIdName', 'actions'];
  displayedColumns: string[] = ['select', 'name', 'customValuesIsAccount', 'customValuesIsJob', 'email', 'phoneNumber', 'statusName', 'Tags', 'ownerIdName', 'actions'];
  dataSource = new MatTableDataSource<any>([]);

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAdjustedColor(
    color: string,
    targetLightness: number,
    saturationAdjustmentFactor: number = 0
  ): string {
    const hex = this.parseColorToHex(color);

    const r = parseInt(hex.substring(1, 3), 16) / 255;
    const g = parseInt(hex.substring(3, 5), 16) / 255;
    const b = parseInt(hex.substring(5, 7), 16) / 255;

    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h: number = 0,
      s: number,
      l: number = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    const targetL = targetLightness / 100;

    const blendFactor = 0.6;
    let newL = l + (targetL - l) * blendFactor;


    newL = Math.max(0, Math.min(1, newL));
    let newS = s;
    if (newL * 100 > 90 && s > 0.1) { // Only adjust if not already desaturated

      const lightnessProximityToWhite = (newL * 100 - 90) / 10;
      newS = s * (1 - lightnessProximityToWhite * saturationAdjustmentFactor);
      newS = Math.max(0, newS);
    }


    return `hsl(${(h * 360).toFixed(0)}, ${(newS * 100).toFixed(0)}%, ${(newL * 100).toFixed(0)}%)`;
  }


  private parseColorToHex(color: string): string {

    const div = document.createElement('div');
    div.style.color = color;
    document.body.appendChild(div);


    const computed = window.getComputedStyle(div).color;
    document.body.removeChild(div);

    const rgb = computed.match(/\d+/g).map(Number);
    return '#' + rgb.map(x => {
      const hex = x.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');
  }

  cancelBulkSelection() {
    this.selection.clear();
    this.selectionLead = [];
    this.leadIdList = [];

  }

  handlePageEvent(event: PageEvent): void {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getProduct();
  }
  announceSortChange(sortState: Sort): void {
    const customCol = this.allColumns.find(c => c.key === sortState.active);

    if (sortState.direction) {
      // Handle customValue key
      if (customCol && customCol.key.includes('customValue')) {
        this.sortParam = `${customCol.name}_cust,${sortState.direction}`;
      } else {
        this.sortParam = `${sortState.active},${sortState.direction}`;
      }
    } else {
      this.sortParam = 'createdDate,desc';
    }

    this.page = 0;
    this.getProduct();
  }

  addColumn(columnKey: string): void {
    if (!this.displayedColumns.includes(columnKey)) {
      const actionIndex = this.displayedColumns.indexOf('actions');
      this.displayedColumns.splice(actionIndex, 0, columnKey);
      this.saveColumnPreferences(); // MODIFIED: Save after adding
    }
  }
  pageSizeOptions: number[] = [10, 25, 50, 100];

  saveColumnPreferences(): void {
    localStorage.setItem('leadsDisplayedColumns', JSON.stringify(this.displayedColumns));
  }

  getAvailableColumns(): { key: string; name: string; }[] {
    return this.allColumns.filter(col => !this.displayedColumns.includes(col.key));
  }

  removeColumnTwo(columnKey: string): void {
    this.displayedColumns = this.displayedColumns.filter(key => key !== columnKey);
    this.saveColumnPreferences(); // MODIFIED: Save after removing
  }

  getInitialsTwo(name: string | null): string {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  }

  editingCell: { rowId: any; colProperty: string } | null = null;

  editingElement: any = null;
  editingCol: any = null;

  startEdit(rowId: any, colProperty: string, element: any, col: any) {

    const fieldMeta = this.filterSelectObj.find(f => f.property === colProperty);

    if (fieldMeta) {
      col.inputType = fieldMeta.type || 'text';
      col.options = fieldMeta.options || [];
    } else {
      col.inputType = 'text';
      col.options = [];
    }

    this.editingCell = { rowId, colProperty };
    this.editingElement = element;
    this.editingCol = col;
  }

  stopEdit() {
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;
  }

  closeEdit(leadId, key, value) {
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;
  }

  saveEdit(leadId, key, value) {

    let object = {
      "entityId": leadId,
      [key]: value
    }

    // this.companiesService.editLead(object, leadId).subscribe(
    //   (response) => {
    //     if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
    //       this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    //     } else {
    //       this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
    //     }
    //   },
    //   (err) => {
    //   });

  }

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;
  filtereddropdownTypeList: any;
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();
  protected _onDestroy = new Subject<void>();
  protected _onDestroy1 = new Subject<void>();



  getUserDropDownList() {

    let val: any = localStorage.getItem('userType')

    if (val == null) {
      val = 0;
    } else if (val == 'salesUser') {
      val = 1;
    } else {
      val = 0;
    }

    // console.log(val);

    if (!this.router.url.includes('crmAnalytics') && val == 0) {

      this.usersService.getAllUserStatusDropDown().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    } else {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    }

  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}